/* SCRIPTS */
jQuery(function ($) {
    $('#header-waycarbon .header-switch-lang .current-lang').on('click', function (e) {
        e.preventDefault();
        $('#header-waycarbon .header-switch-lang .header-other-lang').slideToggle('slow');
    });

    $('#btn-mobile').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('#header-waycarbon .header-nav-wrap').toggleClass('active');
        $('#header-waycarbon').toggleClass('active');
    });

    $('#header-nav-wrap li.menu-item-has-children').on('click', function(e){
        if (e.target === this) {
            e.preventDefault();
            $(this).siblings('li.menu-item-has-children').children('.sub-menu:visible').slideUp();
            $(this).children('.sub-menu').slideToggle();
        }
    });

    $('#header-waycarbon #header-nav-wrap li.menu-item-has-children > a[href="#"]').on('click', function(e) {
        e.preventDefault();
        $(this).siblings('.sub-menu').slideToggle();
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest('#header-nav-wrap').length) {
            $('#header-waycarbon #header-nav-wrap .sub-menu').slideUp();
        }
    });

    if (window.screen.width > 1080) {
        $(window).on('scroll', function() {
            if ($(window).scrollTop() > 20) {
                $('#header-waycarbon #header-nav-wrap .sub-menu').slideUp();
            }
        });
    }

    $('.box-share .btn-share').on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.buttons-share').slideToggle();
    });
    $('.box-share').mouseleave(function (e) {
        e.preventDefault();
        $(this).children('.buttons-share').slideUp();
    });

    $('.mask-date').mask('00/00/0000');
    $('.mask-time').mask('00:00:00');
    $('.mask-cep').mask('00000-000');    
    $('.mask-cpf').mask('000.000.000-00', { reverse: true });
    $('.mask-cnpj').mask('00.000.000/0000-00', { reverse: true });
    $('.mask-money').mask('000.000.000.000.000,00', { reverse: true });

    var TELMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    TELOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(TELMaskBehavior.apply({}, arguments), options);
        }
    };

    $('.mask-tel').mask(TELMaskBehavior, TELOptions);

    $('.mask-input-cpf input').mask('000.000.000-00');
    $('.mask-input-cep input').mask('00000-000');
    $('.mask-input-tel input').mask(TELMaskBehavior, TELOptions);

    $('#btn-open-mobile').on('click', function (e) {
        e.preventDefault;
        $('#nav-header').slideToggle();
    });
    $('#btn-close-mobile').on('click', function (e) {
        e.preventDefault;
        $('#nav-header').slideToggle();
    });

    if($('#sidebar-info').length > 0){

        var sidebarsize = $('#sidebar-info').outerHeight();
        var sidebaroffset = $('#sidebar-info').offset();
        var sidebarposition = sidebarsize + sidebaroffset.top;
    
        $(window).scroll(function(){
            
            var windowheight = $(window).height();
            var scrollsize = $(window).scrollTop();
            var windowposition = windowheight + scrollsize;
    
            if( windowposition > sidebarposition ){
                $('#sidebar-info .info-about').hide();
                $('#sidebar-info .course-info-sidebar').addClass('sticky-top');
            }else{
                $('#sidebar-info .info-about').show();
                $('#sidebar-info .course-info-sidebar').removeClass('sticky-top');
            }
            
    
        });
    }

});